<template>
  <div
    class="search flex items-center"
    :class="newDesign && 'new-design'"
  >
    <input
      v-model="filter"
      class="col"
      :placeholder="filterPlaceholder"
      type="text"
    />
    <QIcon
      v-if="filter"
      class="q-mr-sm cursor-pointer"
      color="primary"
      name="ion-close-circle"
      :size="$isDesktop ? '19px' : '14px'"
      @click="filter = ''"
    />
    <a
      v-if="!hideTeamOptions"
      class="dropdown flex items-center"
      :class="$isDesktop && !newDesign ? 'q-pr-md' : 'q-pr-sm'"
      href="#"
      @click.prevent
    >
      <div class="flex items-center">
        <span
          v-if="$isDesktop"
          class="q-ml-sm"
        >
          {{ $t("stream_sharing_search_input.teams") }}
        </span>
      </div>

      <QIcon
        class="q-ml-md dropdown-icon"
        :name="dropdownIcon"
        size="24px"
      />

      <QMenu v-model="open">
        <QList>
          <QItem
            v-for="(team, index) in teams"
            :key="index"
            :active="filter === team"
            active-class="bg-primary text-white"
            class="flex items-center"
            clickable
            @click="selectOption(team)"
          >
            <span class="text-paragraph q-ml-sm">
              {{ team }}
            </span>
          </QItem>
        </QList>
      </QMenu>
    </a>
  </div>
</template>

<script>
export default {
  name: "StreamSharingSearchInput",
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    teams: {
      type: Array,
      required: true,
    },
    newDesign: {
      type: Boolean,
    },
    hideTeamOptions: {
      type: Boolean,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      open: false,
    };
  },
  computed: {
    filter: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
    dropdownIcon() {
      if (this.newDesign)
        return this.open ? "keyboard_arrow_up" : "keyboard_arrow_down";

      return "ion-md-arrow-dropdown";
    },
    filterPlaceholder() {
      if (this.hideTeamOptions) {
        return this.$t("stream_sharing_search_input.placeholder_team_hidden");
      }

      return this.$t("stream_sharing_search_input.placeholder");
    },
  },
  methods: {
    toggleDropdown() {
      this.open = !this.open;
    },
    selectOption(option) {
      this.filter = option;
      this.toggleDropdown();
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown {
  background: $silver-white;
  border-left: 1px solid $secondary;

  :deep(.q-menu :deep(.q-item.active)) {
    background: $secondary;
  }
}

.new-design {
  .search {
    overflow: hidden;
    border-radius: 3px;
    background: $white;
    border: 1px solid $hover-background;
    padding: 0 0 0 10px;

    .dropdown {
      height: $text-input-height;
      background: $silver-whiter !important;
    }

    input {
      font-size: 14px;
      width: 100%;
      height: $text-input-height;
      background: $white;
    }
  }

  .dropdown-icon {
    color: rgba($black, 0.25);
  }
}
</style>
